const TEXT = {
    ru: {
        title: 'Не удалось загрузить приложение',
        description: 'Попробуйте обновить страницу. Если ошибка повторится, напишите в поддержку.',
        reload: 'Обновить страницу',
    },
    en: {
        title: 'Failed to load the application',
        description: 'Please reload the page. If the error persists, contact support.',
        reload: 'Reload page',
    },
};
export function renderBootstrapError() {
    const text = navigator.language?.toLowerCase().startsWith('ru') ? TEXT.ru : TEXT.en;
    const root = document.getElementById('root') ?? document.body;
    const wrapper = document.createElement('div');
    wrapper.setAttribute('role', 'alert');
    wrapper.style.cssText =
        'min-height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:center;' +
            'gap:12px;padding:24px;box-sizing:border-box;text-align:center;' +
            'font-family:system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;color:#1f2937;background:#fff;';
    const title = document.createElement('h1');
    title.textContent = text.title;
    title.style.cssText = 'margin:0;font-size:20px;font-weight:600;';
    const description = document.createElement('p');
    description.textContent = text.description;
    description.style.cssText = 'margin:0;max-width:420px;font-size:14px;line-height:1.5;color:#4b5563;';
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = text.reload;
    button.style.cssText =
        'margin-top:8px;padding:10px 20px;border:0;border-radius:8px;cursor:pointer;' +
            'font-size:14px;font-weight:500;color:#fff;background:#2563eb;';
    button.addEventListener('click', () => window.location.reload());
    wrapper.append(title, description, button);
    root.replaceChildren(wrapper);
}
